import React, { useState } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { Box, Typography } from "@material-ui/core";
import LinkMui from "@material-ui/core/Link";
export default function PdfViewer(props) {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <Box boxShadow={3} sx={{ borderRadius: 8 }}>
      <Box>
        <Typography align="center" variant="h4">
          {props.type}
        </Typography>
        <Typography align="center" variant="subtitle2">
          Download your report{" "}
          <LinkMui href={props.url} target="_blank">
            <strong>here:</strong>
          </LinkMui>
        </Typography>
      </Box>

      <Box
        boxShadow={3}
        sx={{
          height: "100%",
          maxWidth: "100%",
          maxHeight: "700px",
          boxShadow: 4,
          overflow: "auto",
          border: "black",
          filter: props.blur,
        }}
      >
        {/* <Document
          file={{
            url: props.url,
          }}
          onLoadSuccess={onDocumentLoadSuccess}
          renderMode="svg"
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              size="A4"
              scale={1.17}
              key={`page_${index + 1}`}
              pageNumber={index + 1}
            />
          ))}
        </Document> */}

        <>
          <iframe
            src={props.url}
            width="100%"
            height="800px"
            frameBorder="0"
            title="slides"
          ></iframe>
        </>

      </Box>
    </Box>
  );
}
